import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  GET_AZURE_METRICS_FAILED,
  GET_AZURE_METRICS_FAILED_SUCCESS,
  GET_AZURE_METRICS_FAILED_ERROR,
} from "./constant";

import { getAzureMetricsFailedApi } from "./api";

/**
 * action Type of GET_DASHBOARD_INFO
 * @param {Object} action
 */
function* getAzureMetricsFailedList(params) {
  try {
    const provider = yield select(state => state.CloudProviderStore ? state.CloudProviderStore.selectedProvider : "azure");
    const data = yield call(getAzureMetricsFailedApi, params, provider);

    yield put({ type: GET_AZURE_METRICS_FAILED_SUCCESS, data });
  } catch (error) {
    yield put({ type: GET_AZURE_METRICS_FAILED_ERROR, error });
  }
}

/**
 * Get Login Saga
 */
export function* manageAzureMetricsFailedSaga() {
  yield takeLatest(GET_AZURE_METRICS_FAILED, getAzureMetricsFailedList);
}
